import React from "react"

const FixedFooter = () => (
  <div className="fixed-footer d-none d-md-block">
    <p>© 2021 Voltamond SA. All rights reserved.</p>
  </div>
)

export default FixedFooter
